import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const ModalManagerContext = createContext(
  new Proxy(
    {},
    {
      get: (obj, prop) => {
        if (prop === "isUnavilable") {
          return true;
        }
        throw new Error(
          "ModalManagerContext.get(): cannot be accessed outside a modal"
        );
      },
      set: () => {
        throw new Error(
          "ModalManagerContext.set(): cannot be accessed outside a modal"
        );
      },
      apply: () => {
        throw new Error(
          "ModalManagerContext.apply(): cannot be accessed outside a modal"
        );
      }
    }
  )
);
function useModalContentManager() {
  return useContext(ModalManagerContext);
}
function ModalContentManagerProvider(props) {
  return /* @__PURE__ */ jsx(ModalManagerContext.Provider, { value: props.modal, children: props.children });
}

export { ModalContentManagerProvider, ModalManagerContext, useModalContentManager };
//# sourceMappingURL=notifier.modal-manager.js.map
